// extracted by mini-css-extract-plugin
module.exports = {"notificationsWrapper":"Notifications_notificationsWrapper__38lP9"};